import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, Collapse, Stack, Typography } from "@mui/material";
import { useState } from "react";

const ExpenseSectionAccordionTitle = ({ title, subtitle, collapsedAction }) => (
  <Stack
    direction={{ xs: "column", sm: "row" }}
    gap={{ xs: 0.25, sm: 1.5 }}
    alignItems={{ xs: "flex-start", sm: "baseline" }}
    sx={{ flex: 1, minWidth: 0 }}
  >
    <Typography color="primary" sx={{ fontWeight: 1000 }}>
      {title}
    </Typography>
    {subtitle && (
      <Typography color="primary" sx={{ fontSize: 13, fontWeight: 500 }}>
        {subtitle}
      </Typography>
    )}
    {collapsedAction && (
      <Box sx={{ mt: { xs: 0.5, sm: 0 } }}>
        {collapsedAction}
      </Box>
    )}
  </Stack>
);

const ExpenseSectionAccordion = ({
  title,
  subtitle,
  collapsedAction,
  defaultExpanded = true,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(defaultExpanded);

  const handleToggle = () => {
    setIsOpen((currentValue) => !currentValue);
  };

  return (
    <Box
      className="qub-simple-accordion"
      sx={{
        border: "1px solid #ccc",
        overflow: "hidden",
      }}
    >
      <Box
        onClick={handleToggle}
        sx={{
          alignItems: "center",
          cursor: "pointer",
          display: "flex",
          gap: 1,
          justifyContent: "space-between",
          px: "15px",
          py: "10px",
        }}
      >
        <ExpenseSectionAccordionTitle
          title={title}
          subtitle={subtitle}
          collapsedAction={!isOpen ? collapsedAction : null}
        />
        <ExpandMoreIcon
          sx={{
            flexShrink: 0,
            transition: "transform 0.3s ease",
            transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
          }}
        />
      </Box>
      <Collapse in={isOpen} timeout="auto">
        <Box
          sx={{
            backgroundColor: "#fff",
            px: "15px",
            py: "10px",
          }}
        >
          {children}
        </Box>
      </Collapse>
    </Box>
  );
};

export default ExpenseSectionAccordion;
